import { Box, Button } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import React = require('react');

type SubmitButtonProps = {
  isDisabled: boolean;
};

export const SubmitButton: React.FC<SubmitButtonProps> = ({ isDisabled }) => {
  return (
    <Button
      isDisabled={isDisabled}
      type="submit"
      rightIcon={<Icon icon="chevron-right" />}
      leftIcon={<Box w={'16px'} />}
      height={'60px'}
      width="full"
      maxWidth="200px"
      justifyContent="space-between">
      Continue
    </Button>
  );
};
